import * as Yup from "yup";
import { CAR_DELIVERY_OPTIONS } from "../../../utils/constants/carEstimate";

export const auctionFormSchema = Yup.object().shape({
  // Basic field validations
  reservePrice: Yup.string() // Changed from number to string to handle input better
    .required("Reserve price is required")
    .test(
      "is-valid-price",
      "Reserve price must be at least $100",
      (value) => !isNaN(value) && Number(value) >= 100
    ),

  // Auction type selections
  localAuction: Yup.boolean(),
  exportAuction: Yup.boolean().test(
    "at-least-one-auction",
    "At least one auction type (Local or Export) must be selected",
    function (value) {
      return this.parent.localAuction || value;
    }
  ),

  // Local auction options
  localAuctionTimed: Yup.boolean(),
  localAuctionBuyNow: Yup.boolean().test(
    "local-auction-type",
    "At least one local auction type must be selected if Local Auction is enabled",
    function (value) {
      return (
        !this.parent.localAuction || this.parent.localAuctionTimed || value
      );
    }
  ),

  // Export auction options
  exportAuctionTimed: Yup.boolean(),
  exportAuctionBuyNow: Yup.boolean().test(
    "export-auction-type",
    "At least one export auction type must be selected if Export Auction is enabled",
    function (value) {
      return (
        !this.parent.exportAuction || this.parent.exportAuctionTimed || value
      );
    }
  ),

  // Local auction timed dates/times
  localAuctionDate: Yup.date()
    .nullable()
    .when(["localAuction", "localAuctionTimed"], {
      is: (localAuction, localAuctionTimed) =>
        localAuction && localAuctionTimed,
      then: () =>
        Yup.date().nullable().required("Local auction date is required"),
      otherwise: () => Yup.date().nullable(),
    }),
  localAuctionTime: Yup.string()
    .nullable()
    .when(["localAuction", "localAuctionTimed"], {
      is: (localAuction, localAuctionTimed) =>
        localAuction && localAuctionTimed,
      then: () => Yup.string().required("Local auction time is required"),
      otherwise: () => Yup.string().nullable(),
    }),

  // Local buy now dates/times
  localBuyNowDate: Yup.date()
    .nullable()
    .when(["localAuction", "localAuctionBuyNow"], {
      is: (localAuction, localAuctionBuyNow) =>
        localAuction && localAuctionBuyNow,
      then: () =>
        Yup.date().nullable().required("Local buy now date is required"),
      otherwise: () => Yup.date().nullable(),
    }),
  localBuyNowTime: Yup.string()
    .nullable()
    .when(["localAuction", "localAuctionBuyNow"], {
      is: (localAuction, localAuctionBuyNow) =>
        localAuction && localAuctionBuyNow,
      then: () => Yup.string().required("Local buy now time is required"),
      otherwise: () => Yup.string().nullable(),
    }),

  // Export auction timed dates/times
  exportAuctionDate: Yup.date()
    .nullable()
    .when(["exportAuction", "exportAuctionTimed"], {
      is: (exportAuction, exportAuctionTimed) =>
        exportAuction && exportAuctionTimed,
      then: () =>
        Yup.date().nullable().required("Export auction date is required"),
      otherwise: () => Yup.date().nullable(),
    }),
  exportAuctionTime: Yup.string()
    .nullable()
    .when(["exportAuction", "exportAuctionTimed"], {
      is: (exportAuction, exportAuctionTimed) =>
        exportAuction && exportAuctionTimed,
      then: () => Yup.string().required("Export auction time is required"),
      otherwise: () => Yup.string().nullable(),
    }),

  // Export buy now dates/times
  exportBuyNowDate: Yup.date()
    .nullable()
    .when(["exportAuction", "exportAuctionBuyNow"], {
      is: (exportAuction, exportAuctionBuyNow) =>
        exportAuction && exportAuctionBuyNow,
      then: () =>
        Yup.date().nullable().required("Export buy now date is required"),
      otherwise: () => Yup.date().nullable(),
    }),
  exportBuyNowTime: Yup.string()
    .nullable()
    .when(["exportAuction", "exportAuctionBuyNow"], {
      is: (exportAuction, exportAuctionBuyNow) =>
        exportAuction && exportAuctionBuyNow,
      then: () => Yup.string().required("Export buy now time is required"),
      otherwise: () => Yup.string().nullable(),
    }),

  // Delivery options
  deliveryOption: Yup.string()
    .oneOf(
      [CAR_DELIVERY_OPTIONS.Pickup, CAR_DELIVERY_OPTIONS.Dropoff],
      "Invalid delivery option"
    )
    .required("Delivery option is required"),
  address: Yup.string().when("deliveryOption", {
    is: CAR_DELIVERY_OPTIONS.Pickup,
    then: () => Yup.string().required("Address is required for pickup"),
    otherwise: () => Yup.string().nullable(),
  }),
  pickupDate: Yup.date()
    .nullable()
    .required("Pickup/drop off date is required"),
  lat: Yup.string(),
  long: Yup.string(),
});
